module.exports = __webpack_public_path__ + "static/media/segment_2.81b66d59.png";